import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Typography,
  Grid,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import SettingsIcon from '@material-ui/icons/Settings';
import { ManualCurtainControl } from './ManualCurtainControl';
import { AutomaticCurtainControl } from './AutomaticCurtainControl';
import { UserContext } from '../../../context/UserProvider';
import { db } from '../../../config/firebase';

// --- ESTILOS CON makeStyles (Típico de MUI v4) ---
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  modeCard: {
    padding: theme.spacing(3),
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  cardIcon: {
    fontSize: 40,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  tableContainer: {
    marginTop: theme.spacing(5),
  },
  tableHead: {
    backgroundColor: theme.palette.grey[200],
  },
  tableHeadCell: {
    fontWeight: 'bold',
  },
}));

// --- DATOS DE EJEMPLO ---
// En una aplicación real, esto vendría de tu API
const cortinasData = [
  { id: 1, nombre: 'Cortina Invernadero 1', ubicacion: 'Nave A', modo: 'Automático', estado: 'Cerrada (20%)' },
  { id: 2, nombre: 'Cortina Germinación', ubicacion: 'Nave B', modo: 'Manual', estado: 'Abierta (100%)' },
  { id: 3, nombre: 'Cortina Principal', ubicacion: 'Oficina', modo: 'Automático', estado: 'Cerrada (0%)' },
  { id: 4, nombre: 'Cortina Almacén', ubicacion: 'Bodega Norte', modo: 'Desactivado', estado: 'Posición desconocida' },
];

function showCurtainStatus(status) {
  switch (status) {
    case 'open':
      return 'Abierta';
    case 'close':
      return 'Cerrada';
    case 'closed-interrupted':
      return 'Cerrado Interrumpido';
    case 'open-interrupted':
      return 'Apertura Interrumpido';
    default:
      return 'Desconocido';
  }
}


export const CurtainManagement = () => {
	const classes = useStyles();
  const { usuario, currentMac, canIdIrrigation } = useContext(UserContext);
  const [view, setView] = useState('menu'); // 'menu' | 'manual' | 'automatic'
  const [curtainsData, setCurtainsData] = useState([])

  // --- MANEJADORES DE EVENTOS ---
  // Aquí integrarías tu lógica de enrutamiento (ej. con React Router)
  const handleNavigate = (path) => {
    console.log(`Navegando a: ${path}`);
    if (path === '/curtains/manual') setView('manual');
    if (path === '/curtains/automatic') setView('automatic');
    // Ejemplo con React Router: history.push(path);
  };

  const handleBackToMenu = () => {
    setView('menu');
  };

  useEffect(() => {
    const fetchCurtainsData = async () => {
      if (usuario && usuario.username) {
        try {
          const docRef = db.collection(usuario.username).doc("curtainControl");
          const docSnapshot = await docRef.get();
          if (docSnapshot.exists) {
            const data = docSnapshot.data();
            const registeredCurtains = data.registeredCurtains
            setCurtainsData(registeredCurtains)
            console.log("Esto es registeredCurtains:",registeredCurtains)
          }
          
        } catch (error) {
          console.error(`Error al obtener los datos de las cortinas: ${error}`)
        }
      }
    }
    fetchCurtainsData();
  }, [usuario.username,usuario])
  

  return (
	<Container className={classes.root} maxWidth="lg">
      {view === 'menu' && (
        <>
      {/* --- SECCIÓN 1: CABECERA Y ACCIÓN PRINCIPAL --- */}
      <Grid container justifyContent="space-between" alignItems="center" className={classes.header}>
        <Grid item>
          <Typography variant="h4" component="h1" gutterBottom>
            Gestión de Cortinas
          </Typography>
        </Grid>
        {/* --- Agregar boton para registrar nueva cortina (OPCIONAL)--- */}
        {/* <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenNewCurtainForm}
          >
            Registrar Nueva Cortina
          </Button>
        </Grid> */}
      </Grid>

      {/* --- SECCIÓN 2: MODOS DE OPERACIÓN --- */}
      <Box mb={5}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Modos de Operación
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper className={classes.modeCard} elevation={2} onClick={() => handleNavigate('/curtains/manual')}>
              <TouchAppIcon className={classes.cardIcon} />
              <Typography variant="h5" component="h2" gutterBottom>
                Control Manual
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Toma el control directo para subir o bajar las cortinas en tiempo real.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={classes.modeCard} elevation={2} onClick={() => handleNavigate('/curtains/automatic')}>
              <SettingsIcon className={classes.cardIcon} />
              <Typography variant="h5" component="h2" gutterBottom>
                Control Automático
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Configura y gestiona las reglas para que las cortinas operen solas.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* --- SECCIÓN 3: TABLA DE ESTADO ACTUAL --- */}
      <div className={classes.tableContainer}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Estado Actual de Cortinas
        </Typography>
        <Paper>
          <TableContainer>
            <Table aria-label="tabla de estado de cortinas">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.tableHeadCell}>Nombre</TableCell>
                  {/* <TableCell className={classes.tableHeadCell}>Ubicación</TableCell>
                  <TableCell className={classes.tableHeadCell}>Modo</TableCell> */}
                  <TableCell className={classes.tableHeadCell}>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {curtainsData?.map((cortina) => (
                  <TableRow key={cortina.id}>
                    <TableCell component="th" scope="row">
                      {cortina.name}
                    </TableCell>
                    {/* <TableCell>{cortina.ubicacion}</TableCell>
                    <TableCell>{cortina.modo}</TableCell> */}
                    <TableCell>{showCurtainStatus(cortina.status)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
        </>
      )}

      {view !== 'menu' && (
        <>
          <Grid container justifyContent="space-between" alignItems="center" className={classes.header}>
            <Grid item>
              <Typography variant="h4" component="h1" gutterBottom>
                {view === 'manual' ? 'Control Manual' : 'Control Automático'}
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="default" onClick={handleBackToMenu}>
                Volver
              </Button>
            </Grid>
          </Grid>

          {view === 'manual' && <ManualCurtainControl 
                                curtainsData={curtainsData} 
                                username={usuario.username} 
                                currentMac={currentMac} 
                                canIdIrrigation={canIdIrrigation} />}
          {view === 'automatic' && <AutomaticCurtainControl />}
        </>
      )}
    </Container>
  )
}
